import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import { Link } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const NavigationHeadPaper = styled(Paper)(({ theme }) => ({
  justifyContent: 'space-between',
  display: 'flex',
  borderRadius: '0',
  height: '5rem',
  width: 'var(--viewportWidth)',
  position: 'sticky',
  textAlign: 'center',
  background: theme.palette.primary.dark,
}))

export const NavigationLogoLink = styled(Link)(({}) => ({
  alignSelf: 'center',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
}))

export const Logo = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '18rem',
  height: 'auto',
}))

export const AppName = styled(Typography)(({ theme }) => ({
  marginRight: 'auto',
  padding: '0 1rem',
  fontSize: '1.6rem',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

export const NavigationTabs = styled(Tabs)(({ theme }) => ({
  '& a': {
    color: 'white',
  },
  '& .Mui-selected': {
    color: 'white !important',
    background: theme.palette.primary.main,
  },
  '& .MuiTabs-scroller': {
    display: 'flex',
  },
}))

export const LogOutTab = styled(Tab)(({ theme }) => ({
  background: theme.palette.error.dark,
  color: 'white',
}))

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */
